import moment from 'moment';
import * as ClubFormCtx from './club-form-context';

export const shiftImagesLeft = (imageObj, index) =>
  Object.values(imageObj).reduce(
    (acm, cur, i) =>
      i <= index
        ? acm
        : {
            ...acm,
            [i - 1]: cur,
            [i]: { image_attachment: null, preview: null, id: null, isLoading: false },
          },
    imageObj
  );

export const swapImgsLeft = (imgObj, sourceIndex, targetIndex, isLoading) => {
  const IMG_LIST = Object.values(imgObj);
  const SMALLER_INDEX = sourceIndex < targetIndex ? sourceIndex : targetIndex;
  let LARGER_INDEX = sourceIndex > targetIndex ? sourceIndex : targetIndex;
  if (LARGER_INDEX > 6) LARGER_INDEX = 6;

  if (sourceIndex < targetIndex) {
    // shift left
    const SMALLER = imgObj[SMALLER_INDEX];
    return IMG_LIST.reduce((acm, cur, i) => {
      if (i < SMALLER_INDEX || i > LARGER_INDEX) return { ...acm };
      else if (i === SMALLER_INDEX) return { ...acm, [i]: { ...acm[i + 1], isLoading } };
      else if (i === LARGER_INDEX) return { ...acm, [i]: { ...SMALLER, isLoading } };
      else return { ...acm, [i]: { ...imgObj[i + 1], isLoading } };
    }, imgObj);
  } else {
    // shift right
    const LARGER = imgObj[LARGER_INDEX];
    return IMG_LIST.reduce((acm, cur, i) => {
      if (i < SMALLER_INDEX || i > LARGER_INDEX) return { ...acm };
      else if (i === SMALLER_INDEX) return { ...acm, [i]: { ...LARGER, isLoading } };
      else return { ...acm, [i]: { ...imgObj[i - 1], isLoading } };
    }, imgObj);
  }
};

export const setClubFromCache = (dispatch, {
  active,
  allow_dancer_reviews,
  allow_under_21_dancers,
  audition_info,
  city,
  dancer_count,
  hours_of_operation,
  id,
  images,
  max_consecutive_shift_count,
  min_dancers_for_free_agent_search,
  name,
  notes,
  number_of_stages,
  organization,
  phone_number,
  profile_options,
  required_documents,
  special_requirements_link,
  square_footage,
  state,
  street_1,
  street_2,
  url,
  zip,
  tier,
  auditions_enabled,
  message_club,
  audition_duration_max,
  audition_applications_max,
  auditions_daily_max,
  business_group,
  business_features
}) => {
  dispatch(
    ClubFormCtx.setClubFormFields({
      id: id,
      name: name,
      street1: street_1,
      street2: street_2,
      city: city,
      state: state,
      zip: zip,
      phoneNumber: phone_number,
      url: url,
      hoursAttributes: hours_of_operation.reduce((acm, { day, open, close, all_day, closed, id }) => {
        let openTime;

        if (all_day) openTime = 'allDay';
        else if (closed) openTime = 'closed';
        else openTime = moment.utc(open).format('hh:mmA');

        return {
          ...acm,
          [day]: {
            id,
            open: openTime,
            close: moment.utc(close).format('hh:mmA'),
          },
        };
      }, {}),

      organizationId: organization.id,
      active: active,
      allowDancerReviews: allow_dancer_reviews,
      allowUnder21Dancers: allow_under_21_dancers,
      numberOfStages: String(number_of_stages),
      squareFootage: String(square_footage),
      maxConsecutiveShiftCount: String(max_consecutive_shift_count) || '0',
      profileOptionIds: profile_options.map(({ id }) => id) ?? [],
      requiredDocuments: required_documents ?? [],
      auditionInfo: audition_info ?? '',
      notes: notes ?? '',
      specialRequirementsLink: special_requirements_link,
      minDancersForFreeAgentSearch: min_dancers_for_free_agent_search,
      dancerCount: dancer_count,
      images: images.reduce(
        (acm, { thumb, position, id }) => {
          return { ...acm, [position]: { image_attachment: null, preview: thumb, id, isLoading: false } };
        },
        {
          0: { image_attachment: null, preview: null, isLoading: false, id: null },
          1: { image_attachment: null, preview: null, isLoading: false, id: null },
          2: { image_attachment: null, preview: null, isLoading: false, id: null },
          3: { image_attachment: null, preview: null, isLoading: false, id: null },
          4: { image_attachment: null, preview: null, isLoading: false, id: null },
          5: { image_attachment: null, preview: null, isLoading: false, id: null },
          6: { image_attachment: null, preview: null, isLoading: false, id: null },
        }
      ),
      tier: tier,
      auditionsEnabled: auditions_enabled,
      messageClub: message_club,
      auditionDurationMax: audition_duration_max,
      auditionApplicationsMax: parseInt(audition_applications_max),
      auditionsDailyMax: parseInt(auditions_daily_max),
      businessGroupId: business_group?.id,
      shiftPeriodFilters: business_features?.managers?.shift_period_filters || []
    })
  );
};
